import React, { FunctionComponent } from 'react';
import styles from './FooterBottom.module.scss';
import { WPMenu, WPMenuItem } from 'types/menus';
import { Block, BlockContent, LinkWrapper, Typography } from 'components/elements';
import { createMenuLink } from 'utils/links';

interface OwnProps {
  menu: WPMenu;
}

type FooterBottomProps = JSX.IntrinsicElements['div'] & OwnProps;

const FooterBottom: FunctionComponent<FooterBottomProps> = props => {
  const { menu, ...rest } = props;
  const { items } = menu || {};

  return (
    <Block id="footer-bottom" data-module="footer-bottom" width="container" theme="white">
      <BlockContent>
        <div>
          <div {...rest} className={styles.content}>
            <div className={styles.container}>
              {items.map((item: WPMenuItem) => (
                <LinkWrapper className={styles.link} href={createMenuLink(item)} key={item.ID}>
                  <Typography mobile="new_ibm_regular_16" tablet="new_ibm_regular_16" desktop="new_ibm_regular_16" as="span">
                    {item.title}
                  </Typography>
                </LinkWrapper>
              ))}
            </div>
          </div>
        </div>
      </BlockContent>
    </Block>
  );
};

export default FooterBottom;
